import { render, staticRenderFns } from "./InfoPlan.vue?vue&type=template&id=036fb4ac&scoped=true"
import script from "./InfoPlan.vue?vue&type=script&lang=js"
export * from "./InfoPlan.vue?vue&type=script&lang=js"
import style0 from "./InfoPlan.vue?vue&type=style&index=0&id=036fb4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fb4ac",
  null
  
)

export default component.exports